import { ClientTask } from '../../modules/engine/model/client-task.model';
import { FormEntryType } from '../../modules/engine/model/engine-form.model';

export const tasks: ClientTask[] = [
  {
    id: 1,
    name: 'Czy klient odbiera zgodnie z planem?',
    form: [
      {
        type: FormEntryType.RADIO,
        required: true,
        id: 'pickupTime',
        label: 'Czy klient odbiera zgodnie z planem?',
        values: [
          {
            id: 'BELOW_EXPECTATIONS',
            value: 'Poniżej oczekiwań',
          },
          {
            id: 'NOT_PICKING_UP',
            value: 'Nie odbiera',
          },
          {
            id: 'PICKING_UP',
            value: 'Odbiera zgodnie z planem',
          },
          {
            id: 'ABOVE_THE_EXPECTATIONS',
            value: 'Powyżej planu',
          },
        ],
      },
    ],
  },
  {
    id: 2,
    name: 'Siła rynku na którym działa klient',
    form: [
      {
        type: FormEntryType.RADIO,
        required: true,
        id: 'marketPower',
        label: 'Siła rynku na którym działa klient:',
        values: [
          {
            id: 'WEAK',
            value: 'Słaby',
          },
          {
            id: 'NORMAL',
            value: 'Średni/normalny',
          },
          {
            id: 'STRONG',
            value: 'Mocny',
          },
        ],
      },
    ],
  },
  {
    id: 3,
    name: 'Szacunkowy udział CO w portfelu',
    form: [
      {
        type: FormEntryType.RADIO,
        required: true,
        id: 'walletParticipation',
        label: 'Szacunkowy udział CO w portfelu:',
        values: [
          {
            id: '20',
            value: '0%-20%',
          },
          {
            id: '40',
            value: '21%-40%',
          },
          {
            id: '60',
            value: '41%-60%',
          },
          {
            id: '80',
            value: '61%-80%',
          },
          {
            id: '100',
            value: '81%-100%',
          },
        ],
      },
    ],
  },
  {
    id: 4,
    name: 'Komentarz do wizyty',
    form: [
      {
        type: FormEntryType.TEXTAREA,
        required: false,
        id: 'eventComment',
        label: 'Komentarz do wizyty:',
        values: [
          {
            id: 'eventComment',
            value: '',
          },
        ],
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/assets/tasks/tasks.ts